module.exports = __webpack_public_path__ + "static/media/IconoUnidadesFormacion.0b209ef0.svg";